
export default function() {
  $('.announcement .fa-close').on('click', () => {
    $('.announcement').hide();
  });
}
